// Annual Vendor Audit — query-key factory. The stale-after-save convention:
// `queryKey` array literals live only in a *Keys file, so a mutation can
// invalidate the whole module by prefix and no read is invisible to it.
//
// Scope, list, detail and per-vendor history all hang off ONE root, because a
// single write moves all four: releasing an audit changes its detail, its row
// in the year's list, the completeness denominator on the scope read, and the
// vendor record's history strip.

import type { VendorAuditListParams } from "@/api/portfolioAdmin/vendorAuditsApi";

export const vendorAuditKeys = {
  all: ["portfolio-admin", "vendor-audits"] as const,
  list: (params?: VendorAuditListParams) =>
    [
      "portfolio-admin",
      "vendor-audits",
      "list",
      params?.year ?? null,
      params?.vendorId ?? null,
      params?.status ?? null,
    ] as const,
  /** `year` undefined = "whatever year the SERVER says it is" — a distinct
   *  cache slot from any explicit year, which is correct: the two requests
   *  differ. */
  scope: (year?: number) =>
    ["portfolio-admin", "vendor-audits", "scope", year ?? null] as const,
  detail: (auditId: string) =>
    ["portfolio-admin", "vendor-audits", "detail", auditId] as const,
  forVendor: (vendorId: string) =>
    ["portfolio-admin", "vendor-audits", "for-vendor", vendorId] as const,
};
